import {COUNTRY} from 'front-onceforall-core/dist/utils/country';

import {aPlan} from '../../utils/fixtures';

export const subscriptionsInDb = [{
  id: 154546,
  externalId: 'AzyXcqT6il1yU34oi',
  planId: 'fr_experience_v1',
  country: COUNTRY.FRANCE,
  scope: 'GROUP',
  validUntil: '2023-05-24T00:00:00Z',
  depositorServiceAuthorized: false,
  masterPlatform: 'OFA',
  maximumNumberOfStandardProjects: 0,
  maximumNumberOfNominativeProjects: 0,
  maximumNumberOfUserAccounts: 1,
  numberOfNominativeProjects: 0,
  numberOfStandardProjects: 0,
  numberOfUserAccounts: 1,
  referenceId: '811196930',
  renewable: true,
  lastRenewedDate: null,
  broadcastMandateServiceAuthorized: true
}, {
  id: 75434,
  externalId: '6b09644b-ad74-4268-bf63-0d4128f41c5e',
  planId: 'de_professional_1y_v1',
  country: COUNTRY.GERMANY,
  scope: 'ORGANISATION',
  validUntil: '2023-04-05T23:00:00Z',
  depositorServiceAuthorized: true,
  masterPlatform: null,
  registrationNumber: '52773773',
  maximumNumberOfStandardProjects: 4,
  maximumNumberOfNominativeProjects: 6,
  maximumNumberOfUserAccounts: 8,
  numberOfStandardProjects: 2,
  numberOfNominativeProjects: 3,
  numberOfUserAccounts: 4
}, {
  id: 97,
  externalId: 'edca4157-3d97-4348-be9b-5c45671d370d',
  planId: 'de_basic_1y_v1',
  country: COUNTRY.GERMANY,
  scope: 'ORGANISATION',
  validUntil: '2023-04-05T23:00:00Z',
  depositorServiceAuthorized: true,
  masterPlatform: null,
  registrationNumber: '50320789',
  maximumNumberOfStandardProjects: 4,
  maximumNumberOfNominativeProjects: 6,
  maximumNumberOfUserAccounts: 8,
  numberOfStandardProjects: 2,
  numberOfNominativeProjects: 3,
  numberOfUserAccounts: 4
}, {
  id: 630,
  externalId: 'ebe22b78-aaf3-4352-9c81-3148c30c950d',
  planId: 'fr_serenity_1y_v2',
  country: COUNTRY.FRANCE,
  scope: 'GROUP',
  depositorServiceAuthorized: true,
  masterPlatform: null,
  registrationNumber: '813348513',
  maximumNumberOfStandardProjects: 4,
  maximumNumberOfNominativeProjects: 6,
  maximumNumberOfUserAccounts: 8,
  numberOfStandardProjects: 2,
  numberOfNominativeProjects: 3,
  numberOfUserAccounts: 4
}, {
  externalId: 'a81b15de-114b-4f57-aaaf-8a3c636c2212',
  planId: 'de_basic_1y_v1',
  country: COUNTRY.GERMANY,
  scope: 'ORGANISATION',
  validUntil: '2023-04-05T23:00:00Z',
  depositorServiceAuthorized: true,
  masterPlatform: null,
  registrationNumber: '12345678',
  maximumNumberOfStandardProjects: 4,
  maximumNumberOfNominativeProjects: 6,
  maximumNumberOfUserAccounts: 8,
  numberOfStandardProjects: 2,
  numberOfNominativeProjects: 3,
  numberOfUserAccounts: 4
}, {
  id: 9012,
  externalId: 'a81b15de-114b-4f57-aaaf-8a3c636c2212',
  planId: 'fr_serenity_1y_v2',
  country: COUNTRY.FRANCE,
  depositorServiceAuthorized: true,
  masterPlatform: null,
  registrationNumber: '123456789',
  groupIdentifier: '12345678901234',
  maximumNumberOfStandardProjects: 4,
  maximumNumberOfNominativeProjects: 6,
  maximumNumberOfUserAccounts: 8,
  numberOfStandardProjects: 2,
  numberOfNominativeProjects: 3,
  numberOfUserAccounts: 4
}];

export const organisationsBySubscription = [{
  subscriptionId: 75434,
  organisationIds: [2]
}, {
  subscriptionId: 97,
  organisationIds: [1]
}, {
  subscriptionId: 630,
  organisationIds: [3]
}, {
  subscriptionId: 9012,
  organisationIds: [4]
}, {
  subscriptionId: 154546,
  organisationIds: [1168550]
}];

export const plansInDB = [
  aPlan(),
  aPlan({
    externalId: 'fr_collector_sme_1y_v1',
    maxEmployees: null, /* optional */
    price: 0,
    pricePeriod: 'year',
    setupFee: 0,
    currency: 'EUR',
    depositor: false,
    services: [{
      id: 'fr_included_user_v1',
      priority: 1000, /* Priority is always an integer value, the highest the priority, the item shall be displayed at the top. */
      quantity: 6,
      price: null,
      unit: 'user',
      unitPeriod: null
    }, {
      id: 'fr_kbis_purchase_v1',
      priority: 900,
      quantity: 1,
      price: null,
      unit: null,
      unitPeriod: null
    }, {
      id: 'fr_included_collection_mandate_v1',
      priority: 800,
      quantity: 1,
      price: null,
      unit: null,
      unitPeriod: null
    }, {
      id: 'fr_additional_user_v1',
      priority: 1100,
      quantity: 1,
      price: 1290,
      unit: 'user',
      unitPeriod: 'year'
    }, {
      id: 'fr_opera_option_v1',
      priority: 500,
      quantity: 1,
      price: 500,
      unit: null,
      unitPeriod: null
    }]
  }),
  aPlan({
    externalId: 'fr_artisan_1y_v1',
    maxEmployees: 2, /* optional */
    price: 14400,
    pricePeriod: 'year',
    setupFee: 3900,
    currency: 'EUR',
    depositor: true,
    services: [{
      id: 'fr_depositor_v1',
      priority: -1, /* Priority is always an integer value, the highest the priority, the item shall be displayed at the top. */
      quantity: 1,
      price: null,
      unit: null,
      unitPeriod: null
    }, {
      id: 'fr_included_user_v1',
      priority: 1000, /* Priority is always an integer value, the highest the priority, the item shall be displayed at the top. */
      quantity: 6,
      price: null,
      unit: 'user',
      unitPeriod: null
    }, {
      id: 'fr_kbis_purchase_v1',
      priority: 900,
      quantity: 1,
      price: null,
      unit: null,
      unitPeriod: null
    }, {
      id: 'fr_included_collection_mandate_v1',
      priority: 800,
      quantity: 1,
      price: null,
      unit: null,
      unitPeriod: null
    }, {
      id: 'fr_additional_user_v1',
      priority: 1100,
      quantity: 1,
      price: 1290,
      unit: 'user',
      unitPeriod: 'year'
    }, {
      id: 'fr_opera_option_v1',
      priority: 500,
      quantity: 1,
      price: 500,
      unit: null,
      unitPeriod: null
    }]
  }),
  aPlan({
    externalId: 'de_professional_1y_v1',
    maxEmployees: null,
    price: 14400,
    pricePeriod: 'year',
    setupFee: 3900,
    currency: 'EUR',
    depositor: false,
    services: [{
      id: 'de_network_connection_v1',
      priority: 1000,
      quantity: null,
      price: null,
      unit: null,
      unitPeriod: null
    }, {
      id: 'de_document_collect_v1',
      priority: 900,
      quantity: null,
      price: null,
      unit: null,
      unitPeriod: null
    }, {
      id: 'de_subcontractor_dossier_access_v1',
      priority: 800,
      quantity: null,
      price: null,
      unit: null,
      unitPeriod: null
    }, {
      id: 'de_project_subcontractor_documents_v1',
      priority: 700,
      quantity: null,
      price: null,
      unit: null,
      unitPeriod: null
    }, {
      id: 'de_project_subcontractor_management_v1',
      priority: 600,
      quantity: null,
      price: null,
      unit: null,
      unitPeriod: null
    }, {
      id: 'de_project_documents_v1',
      priority: 500,
      quantity: null,
      price: null,
      unit: null,
      unitPeriod: null
    }, {
      id: 'de_included_user_v1',
      priority: 200,
      quantity: 2,
      price: null,
      unit: null,
      unitPeriod: null
    }, {
      id: 'de_included_project_v1',
      priority: 300,
      quantity: 1,
      price: null,
      unit: null,
      unitPeriod: null
    }]
  })
];

export const invoices = [
  {
    id: 'FR01IN-519',
    status: 'PAYMENT_DUE',
    date: '2020-03-05T23:00:00Z',
    dueDate: '2020-04-05T23:00:00Z',
    paymentDate: '2020-03-09T09:36:46Z',
    totalAmount: 46440,
    dueAmount: 0,
    currency: 'EUR',
    billingAddress: {
      firstName: 'Hola',
      lastName: 'Stéphane',
      company: 'MATHILDE B',
      line1: '16 Quai de la Marne',
      city: 'PARIS 19',
      country: 'FR',
      zip: '75019'
    }
  },
  {
    id: 'FR01IN-517',
    status: 'PAID',
    date: '2020-03-05T23:00:00Z',
    dueDate: '2020-04-05T23:00:00Z',
    paymentDate: '2020-03-09T09:36:46Z',
    totalAmount: 46440,
    dueAmount: 0,
    currency: 'EUR',
    billingAddress: {
      firstName: 'Hola',
      lastName: 'Stéphane',
      company: 'MATHILDE B',
      line1: '16 Quai de la Marne',
      city: 'PARIS 19',
      country: 'FR',
      zip: '75019'
    }
  },
  {
    id: 'FR01IN-518',
    status: 'NOT_PAID',
    date: '2020-03-05T23:00:00Z',
    dueDate: '2020-04-05T23:00:00Z',
    paymentDate: '2020-03-09T09:36:46Z',
    totalAmount: 46440,
    dueAmount: 0,
    currency: 'EUR',
    billingAddress: {
      firstName: 'Hola',
      lastName: 'Stéphane',
      company: 'MATHILDE B',
      line1: '16 Quai de la Marne',
      city: 'PARIS 19',
      country: 'FR',
      zip: '75019'
    }
  }
];
